<template>
    <EditModal
        v-model:open="modalVisible"
        :title="title"
        :confirm-loading="confirmLoading"
        :width="1000"
        @ok="handleSubmit"
        @cancel="handleCancel"
    >
        <template #form>
            <a-form
                ref="formRef"
                :model="formData"
                :rules="formRules"
                autocomplete="off"
                layout="vertical"
            >
                <a-collapse
                    v-model:activeKey="sectionsActiveKeys"
                    :bordered="false"
                    class="form-sections-collapse"
                >
                    <!-- 基本資訊 -->
                    <a-collapse-panel key="basic" class="form-section-panel">
                        <template #header>
                            <span class="section-header">基本資訊</span>
                        </template>
                        <a-card
                            class="form-section-card-inner"
                            :bordered="false"
                        >
                            <a-row :gutter="16">
                                <!-- 左側：基本資料 -->
                                <a-col :span="12">
                                    <a-form-item label="名稱" name="name">
                                        <a-input
                                            v-model:value="formData.name"
                                            placeholder="請輸入名稱"
                                        />
                                    </a-form-item>
                                    <a-row :gutter="16">
                                        <a-col :span="12">
                                            <a-form-item
                                                label="分類"
                                                name="category_id"
                                            >
                                                <a-select
                                                    v-model:value="
                                                        formData.category_id
                                                    "
                                                    placeholder="請選擇分類"
                                                    allow-clear
                                                    autocomplete="off"
                                                >
                                                    <a-select-option
                                                        v-for="category in categories"
                                                        :key="category.id"
                                                        :value="category.id"
                                                    >
                                                        {{ category.name }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item
                                                label="屬性"
                                                name="attribute"
                                            >
                                                <a-select
                                                    v-model:value="
                                                        formData.attribute
                                                    "
                                                    placeholder="請選擇屬性"
                                                    autocomplete="off"
                                                >
                                                    <a-select-option
                                                        value="attack"
                                                    >
                                                        攻擊
                                                    </a-select-option>
                                                    <a-select-option
                                                        value="defense"
                                                    >
                                                        防守
                                                    </a-select-option>
                                                    <a-select-option
                                                        value="support"
                                                    >
                                                        支援
                                                    </a-select-option>
                                                    <a-select-option
                                                        value="neutral"
                                                    >
                                                        中性
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                    <a-form-item
                                        label="描述"
                                        name="description"
                                    >
                                        <a-textarea
                                            v-model:value="formData.description"
                                            :rows="3"
                                            placeholder="請輸入描述"
                                        />
                                    </a-form-item>
                                </a-col>
                                <!-- 右側：時間設定 -->
                                <a-col :span="12">
                                    <a-row :gutter="16">
                                        <a-col :span="12">
                                            <a-form-item label="達成即完成">
                                                <a-select
                                                    v-model:value="
                                                        formData.auto_complete
                                                    "
                                                    style="width: 100%"
                                                >
                                                    <a-select-option
                                                        :value="true"
                                                    >
                                                        是
                                                    </a-select-option>
                                                    <a-select-option
                                                        :value="false"
                                                    >
                                                        否
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item label="狀態">
                                                <a-select
                                                    v-model:value="
                                                        formData.is_active
                                                    "
                                                    style="width: 100%"
                                                >
                                                    <a-select-option
                                                        :value="true"
                                                    >
                                                        啟用
                                                    </a-select-option>
                                                    <a-select-option
                                                        :value="false"
                                                    >
                                                        停用
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                    <a-form-item
                                        label="開始時間"
                                        name="start_time"
                                    >
                                        <a-date-picker
                                            v-model:value="formData.start_time"
                                            format="YYYY-MM-DD HH:mm:ss"
                                            placeholder="請選擇開始時間（選填）"
                                            style="width: 100%"
                                            @change="
                                                (d) => {
                                                    formData.start_time =
                                                        applyStartOfDay(d);
                                                }
                                            "
                                        />
                                    </a-form-item>
                                    <a-form-item
                                        label="結束時間"
                                        name="end_time"
                                    >
                                        <a-date-picker
                                            v-model:value="formData.end_time"
                                            format="YYYY-MM-DD HH:mm:ss"
                                            placeholder="請選擇結束時間（選填）"
                                            style="width: 100%"
                                            @change="
                                                (d) => {
                                                    formData.end_time =
                                                        applyEndOfDay(d);
                                                }
                                            "
                                        />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-card>
                    </a-collapse-panel>

                    <!-- 可見性規則區塊 -->
                    <a-collapse-panel
                        key="visibility"
                        class="form-section-panel"
                    >
                        <template #header>
                            <span class="section-header">
                                誰可以看到
                                <span class="section-note">
                                    （如果沒有設定則無限制）
                                </span>
                            </span>
                        </template>
                        <a-card
                            class="form-section-card-inner"
                            :bordered="false"
                        >
                            <a-form-item>
                                <div class="rules-section">
                                    <div class="rules-header">
                                        <a-button
                                            type="dashed"
                                            @click="addVisibilityRule"
                                            size="small"
                                        >
                                            <template #icon>
                                                <PlusOutlined />
                                            </template>
                                            新增誰可以看到設定
                                        </a-button>
                                    </div>
                                    <div
                                        v-if="
                                            formData.visibility_rules &&
                                            formData.visibility_rules.length > 0
                                        "
                                        class="rules-list"
                                    >
                                        <div
                                            v-for="(
                                                rule, index
                                            ) in formData.visibility_rules"
                                            :key="index"
                                            class="rule-item"
                                        >
                                            <a-row :gutter="16" align="middle">
                                                <a-col :span="10">
                                                    <a-select
                                                        v-model:value="
                                                            rule.audience_type
                                                        "
                                                        placeholder="選擇誰可以看到"
                                                        style="width: 100%"
                                                        autocomplete="off"
                                                        data-lpignore="true"
                                                        data-form-type="other"
                                                        @change="
                                                            () =>
                                                                handleRuleTypeChange(
                                                                    'visibility',
                                                                    index
                                                                )
                                                        "
                                                    >
                                                        <a-select-option
                                                            v-for="option in missionOptions.visibility_audience_types"
                                                            :key="option.value"
                                                            :value="
                                                                option.value
                                                            "
                                                        >
                                                            {{ option.label }}
                                                        </a-select-option>
                                                    </a-select>
                                                </a-col>
                                                <a-col :span="12">
                                                    <!-- 如果有 options，使用多選下拉選單 -->
                                                    <a-select
                                                        v-if="
                                                            getVisibilityTypeOptions(
                                                                rule.audience_type
                                                            ) &&
                                                            getVisibilityTypeOptions(
                                                                rule.audience_type
                                                            ).length > 0
                                                        "
                                                        v-model:value="
                                                            rule.audience_ref
                                                        "
                                                        mode="multiple"
                                                        :placeholder="
                                                            getVisibilityPlaceholder(
                                                                rule.audience_type
                                                            )
                                                        "
                                                        style="width: 100%"
                                                    >
                                                        <a-select-option
                                                            v-for="opt in getVisibilityTypeOptions(
                                                                rule.audience_type
                                                            )"
                                                            :key="
                                                                opt.id ||
                                                                opt.code ||
                                                                opt.value
                                                            "
                                                            :value="
                                                                opt.id ||
                                                                opt.code ||
                                                                opt.value ||
                                                                opt.name
                                                            "
                                                        >
                                                            {{
                                                                opt.label ||
                                                                opt.name
                                                            }}
                                                        </a-select-option>
                                                    </a-select>
                                                    <!-- 如果是會員類型，使用可多選的搜尋 -->
                                                    <a-select
                                                        v-else-if="
                                                            rule.audience_type ===
                                                            'user'
                                                        "
                                                        v-model:value="
                                                            rule.audience_ref
                                                        "
                                                        mode="multiple"
                                                        show-search
                                                        :filter-option="false"
                                                        :options="
                                                            getUserSearchOptions(
                                                                'visibility',
                                                                index
                                                            )
                                                        "
                                                        :loading="
                                                            getUserSearchLoading(
                                                                'visibility',
                                                                index
                                                            )
                                                        "
                                                        placeholder="搜尋會員名稱（可多選）"
                                                        style="width: 100%"
                                                        @search="
                                                            (val) =>
                                                                handleUserSearch(
                                                                    'visibility',
                                                                    index,
                                                                    val
                                                                )
                                                        "
                                                    ></a-select>
                                                    <!-- 其他情況使用文字輸入 -->
                                                    <a-input
                                                        v-else
                                                        v-model:value="
                                                            rule.audience_ref
                                                        "
                                                        :placeholder="
                                                            getVisibilityInputPlaceholder(
                                                                rule.audience_type
                                                            )
                                                        "
                                                        style="width: 100%"
                                                    />
                                                </a-col>
                                                <a-col :span="2">
                                                    <a-button
                                                        type="text"
                                                        @click="
                                                            removeVisibilityRule(
                                                                index
                                                            )
                                                        "
                                                        size="small"
                                                        class="delete-rule-btn"
                                                    >
                                                        <template #icon>
                                                            <DeleteOutlined />
                                                        </template>
                                                    </a-button>
                                                </a-col>
                                            </a-row>
                                        </div>
                                    </div>
                                    <div v-else class="no-rules">
                                        <a-empty
                                            description="尚未設定誰可以看到"
                                            :image="false"
                                        />
                                    </div>
                                </div>
                            </a-form-item>
                        </a-card>
                    </a-collapse-panel>

                    <!-- 可執行規則區塊 -->
                    <a-collapse-panel
                        key="executable"
                        class="form-section-panel"
                    >
                        <template #header>
                            <span class="section-header">
                                誰可以執行
                                <span class="section-note">
                                    （如果沒有設定則無限制）
                                </span>
                            </span>
                        </template>
                        <a-card
                            class="form-section-card-inner"
                            :bordered="false"
                        >
                            <a-form-item>
                                <div class="rules-section">
                                    <div class="rules-header">
                                        <a-button
                                            type="dashed"
                                            @click="addExecutableRule"
                                            size="small"
                                        >
                                            <template #icon>
                                                <PlusOutlined />
                                            </template>
                                            新增誰可以執行設定
                                        </a-button>
                                    </div>
                                    <div
                                        v-if="
                                            formData.executable_rules &&
                                            formData.executable_rules.length > 0
                                        "
                                        class="rules-list"
                                    >
                                        <div
                                            v-for="(
                                                rule, index
                                            ) in formData.executable_rules"
                                            :key="index"
                                            class="rule-item"
                                        >
                                            <a-row :gutter="16" align="middle">
                                                <a-col :span="10">
                                                    <a-select
                                                        v-model:value="
                                                            rule.actor_type
                                                        "
                                                        placeholder="選擇誰可以執行"
                                                        style="width: 100%"
                                                        autocomplete="off"
                                                        data-lpignore="true"
                                                        data-form-type="other"
                                                        @change="
                                                            () =>
                                                                handleRuleTypeChange(
                                                                    'executable',
                                                                    index
                                                                )
                                                        "
                                                    >
                                                        <a-select-option
                                                            v-for="option in missionOptions.executable_actor_types"
                                                            :key="option.value"
                                                            :value="
                                                                option.value
                                                            "
                                                        >
                                                            {{ option.label }}
                                                        </a-select-option>
                                                    </a-select>
                                                </a-col>
                                                <a-col :span="12">
                                                    <!-- 如果有 options，使用多選下拉選單 -->
                                                    <a-select
                                                        v-if="
                                                            getExecutableTypeOptions(
                                                                rule.actor_type
                                                            ) &&
                                                            getExecutableTypeOptions(
                                                                rule.actor_type
                                                            ).length > 0
                                                        "
                                                        v-model:value="
                                                            rule.actor_ref
                                                        "
                                                        mode="multiple"
                                                        :placeholder="
                                                            getExecutablePlaceholder(
                                                                rule.actor_type
                                                            )
                                                        "
                                                        style="width: 100%"
                                                    >
                                                        <a-select-option
                                                            v-for="opt in getExecutableTypeOptions(
                                                                rule.actor_type
                                                            )"
                                                            :key="
                                                                opt.id ||
                                                                opt.code ||
                                                                opt.value
                                                            "
                                                            :value="
                                                                opt.id ||
                                                                opt.code ||
                                                                opt.value ||
                                                                opt.name
                                                            "
                                                        >
                                                            {{
                                                                opt.label ||
                                                                opt.name
                                                            }}
                                                        </a-select-option>
                                                    </a-select>
                                                    <!-- 如果是會員類型，使用可多選的搜尋 -->
                                                    <a-select
                                                        v-else-if="
                                                            rule.actor_type ===
                                                            'user'
                                                        "
                                                        v-model:value="
                                                            rule.actor_ref
                                                        "
                                                        mode="multiple"
                                                        show-search
                                                        :filter-option="false"
                                                        :options="
                                                            getUserSearchOptions(
                                                                'executable',
                                                                index
                                                            )
                                                        "
                                                        :loading="
                                                            getUserSearchLoading(
                                                                'executable',
                                                                index
                                                            )
                                                        "
                                                        placeholder="搜尋會員名稱（可多選）"
                                                        style="width: 100%"
                                                        @search="
                                                            (val) =>
                                                                handleUserSearch(
                                                                    'executable',
                                                                    index,
                                                                    val
                                                                )
                                                        "
                                                    ></a-select>
                                                    <!-- 其他情況使用文字輸入 -->
                                                    <a-input
                                                        v-else
                                                        v-model:value="
                                                            rule.actor_ref
                                                        "
                                                        :placeholder="
                                                            getExecutableInputPlaceholder(
                                                                rule.actor_type
                                                            )
                                                        "
                                                        style="width: 100%"
                                                    />
                                                </a-col>
                                                <a-col :span="2">
                                                    <a-button
                                                        type="text"
                                                        @click="
                                                            removeExecutableRule(
                                                                index
                                                            )
                                                        "
                                                        size="small"
                                                        class="delete-rule-btn"
                                                    >
                                                        <template #icon>
                                                            <DeleteOutlined />
                                                        </template>
                                                    </a-button>
                                                </a-col>
                                            </a-row>
                                        </div>
                                    </div>
                                    <div v-else class="no-rules">
                                        <a-empty
                                            description="尚未設定誰可以執行"
                                            :image="false"
                                        />
                                    </div>
                                </div>
                            </a-form-item>
                        </a-card>
                    </a-collapse-panel>

                    <!-- 獎勵設定區塊 -->
                    <a-collapse-panel key="rewards" class="form-section-panel">
                        <template #header>
                            <span class="section-header">獎勵設定</span>
                        </template>
                        <a-card
                            class="form-section-card-inner"
                            :bordered="false"
                        >
                            <a-form-item>
                                <div class="rewards-section">
                                    <div class="rewards-header">
                                        <a-button
                                            type="dashed"
                                            @click="addReward"
                                            size="small"
                                        >
                                            <template #icon>
                                                <PlusOutlined />
                                            </template>
                                            新增獎勵
                                        </a-button>
                                    </div>
                                    <div
                                        v-if="
                                            formData.rewards &&
                                            formData.rewards.length > 0
                                        "
                                        class="rewards-list"
                                    >
                                        <div
                                            v-for="(
                                                reward, index
                                            ) in formData.rewards"
                                            :key="index"
                                            class="reward-item"
                                        >
                                            <a-row :gutter="16" align="middle">
                                                <a-col :span="8">
                                                    <a-select
                                                        v-model:value="
                                                            reward.reference_id
                                                        "
                                                        placeholder="選擇獎勵類型"
                                                        style="width: 100%"
                                                        autocomplete="off"
                                                        data-lpignore="true"
                                                        data-form-type="other"
                                                        @change="
                                                            (value) =>
                                                                handleRewardTypeChange(
                                                                    index,
                                                                    value
                                                                )
                                                        "
                                                    >
                                                        <a-select-option
                                                            v-for="option in missionOptions.rewardTypes"
                                                            :key="option.value"
                                                            :value="
                                                                option.value
                                                            "
                                                        >
                                                            {{ option.label }}
                                                        </a-select-option>
                                                    </a-select>
                                                </a-col>
                                                <a-col :span="12">
                                                    <a-input-number
                                                        v-model:value="
                                                            reward.value
                                                        "
                                                        placeholder="獎勵數量"
                                                        style="width: 100%"
                                                        :min="0"
                                                    />
                                                </a-col>
                                                <a-col :span="4">
                                                    <a-button
                                                        type="text"
                                                        @click="
                                                            removeReward(index)
                                                        "
                                                        size="small"
                                                        class="delete-rule-btn"
                                                    >
                                                        <template #icon>
                                                            <DeleteOutlined />
                                                        </template>
                                                    </a-button>
                                                </a-col>
                                            </a-row>
                                        </div>
                                    </div>
                                    <div v-else class="no-rewards">
                                        <a-empty
                                            description="尚未設定獎勵"
                                            :image="false"
                                        />
                                    </div>
                                </div>
                            </a-form-item>
                        </a-card>
                    </a-collapse-panel>
                </a-collapse>
            </a-form>
        </template>
    </EditModal>
</template>

<script setup>
import { ref, reactive, computed, watch, nextTick } from 'vue';
import { message } from 'ant-design-vue';
import { showErrorMessage } from '@/utils/messageHelper';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons-vue';
import dayjs from 'dayjs';
import { applyStartOfDay, applyEndOfDay } from '@/utils/dateTimePicker';
import EditModal from '@/components/common/EditModal.vue';
import { createMission, updateMission, getMissionDetail } from '@/api/missions';
import { searchUsers } from '@/api/users';
import { handleHttpError } from '@/api/errorHandler';
import { processSubmitData } from './missionFormUtils';

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    },
    editingId: {
        type: [Number, String, null],
        default: null
    },
    categories: {
        type: Array,
        default: () => []
    },
    missionOptions: {
        type: Object,
        required: true
    },
    confirmLoading: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:modelValue', 'update:editingId', 'success']);

const modalVisible = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
});

const title = computed(() => {
    return props.editingId ? '編輯主線' : '新增主線';
});

const formRef = ref();
const sectionsActiveKeys = ref(['basic']);

const formData = reactive({
    name: '',
    description: '',
    attribute: undefined,
    category_id: undefined,
    is_repeatable: false,
    is_active: true,
    is_required: true,
    repeat_cycle: undefined,
    max_times_per_cycle: undefined,
    unlock_from_node_id: undefined,
    start_time: undefined,
    end_time: undefined,
    auto_complete: false,
    designated_collaborator: [],
    rewards: [],
    executable_rules: [],
    visibility_rules: []
});

const formRules = {
    name: [{ required: true, message: '請輸入主線任務名稱' }],
    attribute: [{ required: true, message: '請選擇主線任務屬性' }],
    category_id: [{ required: true, message: '請選擇分類' }],
    max_times_per_cycle: [
        {
            validator: async () => {
                // 如果有設置重複週期，最大重複次數必須至少為 1
                if (
                    formData.repeat_cycle &&
                    (!formData.max_times_per_cycle ||
                        formData.max_times_per_cycle < 1)
                ) {
                    return Promise.reject(
                        new Error('有設置重複週期時，最大重複次數至少為 1')
                    );
                }
                return Promise.resolve();
            },
            trigger: ['change', 'blur']
        }
    ]
};

// 會員搜尋相關
const userSearchOptions = ref({});
const userSearchLoading = ref({});
const userSearchTimers = ref({});
const USER_SEARCH_DEBOUNCE_MS = 250;

// 重置表單
const resetForm = () => {
    formData.name = '';
    formData.description = '';
    formData.attribute = undefined;
    formData.category_id = undefined;
    formData.is_repeatable = false;
    formData.is_active = true;
    formData.is_required = true;
    formData.repeat_cycle = undefined;
    formData.max_times_per_cycle = undefined;
    formData.unlock_from_node_id = undefined;
    formData.start_time = undefined;
    formData.end_time = undefined;
    formData.auto_complete = false;
    formData.designated_collaborator = [];
    formData.rewards = [];
    formData.executable_rules = [];
    formData.visibility_rules = [];

    sectionsActiveKeys.value = ['basic'];

    nextTick(() => {
        formRef.value?.resetFields();
        formRef.value?.clearValidate();
    });
};

// 載入編輯資料
const loadEditData = async () => {
    if (!props.editingId) {
        resetForm();
        return;
    }

    try {
        const response = await getMissionDetail(props.editingId);
        if (response.result && response.data) {
            const data = response.data;

            formData.name = data.name || '';
            formData.description = data.description || '';
            formData.attribute = data.attribute;
            // 處理分類 ID：優先使用 category_id，如果沒有則從 category 物件取得
            formData.category_id = data.category_id || data.category?.id;
            formData.is_repeatable = data.is_repeatable || false;
            formData.is_active =
                data.is_active !== undefined ? data.is_active : true;
            formData.is_required =
                data.is_required !== undefined ? data.is_required : true;
            formData.repeat_cycle = data.repeat_cycle;
            formData.max_times_per_cycle = data.max_times_per_cycle;
            formData.unlock_from_node_id = data.unlock_from_node_id;
            formData.start_time = data.start_time
                ? dayjs(data.start_time)
                : undefined;
            formData.end_time = data.end_time
                ? dayjs(data.end_time)
                : undefined;
            formData.auto_complete =
                data.auto_complete !== undefined ? data.auto_complete : false;

            // 處理 designated_collaborator：支援單值或陣列
            if (data.designated_collaborator) {
                formData.designated_collaborator = Array.isArray(
                    data.designated_collaborator
                )
                    ? data.designated_collaborator
                    : [data.designated_collaborator];
            } else {
                formData.designated_collaborator = [];
            }

            // 處理 rewards
            if (data.rewards && Array.isArray(data.rewards)) {
                formData.rewards = data.rewards.map((reward) => {
                    if (reward.reward_type === 'exp') {
                        return {
                            reward_type: 'exp',
                            reference_id: 'exp',
                            value: reward.value
                        };
                    }
                    return {
                        reward_type: reward.reward_type || 'point',
                        reference_id: reward.reference_id,
                        value: reward.value
                    };
                });
            } else {
                formData.rewards = [];
            }

            // 處理 visibility_rules
            if (data.visibility_rules && Array.isArray(data.visibility_rules)) {
                formData.visibility_rules = data.visibility_rules.map(
                    (rule, ruleIndex) => {
                        let audienceRef = [];
                        if (rule.audience_ref) {
                            const refArray = Array.isArray(rule.audience_ref)
                                ? rule.audience_ref
                                : rule.audience_ref.split(',');

                            // 處理名稱字串（可能包含多個名稱，用逗號分隔）
                            const names = rule.audience_name
                                ? rule.audience_name
                                      .split(',')
                                      .map((n) => n.trim())
                                : [];

                            // 根據 audience_type 找到對應的選項
                            const typeConfig =
                                props.missionOptions.visibility_audience_types?.find(
                                    (type) => type.value === rule.audience_type
                                );
                            const options = typeConfig?.options || [];

                            if (options.length > 0) {
                                // 根據選項的 value 類型來轉換
                                audienceRef = refArray.map((ref) => {
                                    // 嘗試在選項中找到匹配的項目
                                    const matchedOption = options.find(
                                        (opt) => {
                                            const optValue =
                                                opt.id ||
                                                opt.code ||
                                                opt.value ||
                                                opt.name;
                                            return (
                                                String(optValue) === String(ref)
                                            );
                                        }
                                    );

                                    if (matchedOption) {
                                        return (
                                            matchedOption.id ||
                                            matchedOption.code ||
                                            matchedOption.value ||
                                            matchedOption.name
                                        );
                                    }
                                    return ref;
                                });
                            } else if (rule.audience_type === 'user') {
                                // 對於 user 類型，需要將名稱加入到搜尋選項中
                                const key = `visibility_${ruleIndex}`;
                                audienceRef = refArray.map((ref, refIndex) => {
                                    const name = names[refIndex] || ref;

                                    // 初始化搜尋選項
                                    if (!userSearchOptions.value[key]) {
                                        userSearchOptions.value[key] = [];
                                    }

                                    // 如果選項中還沒有這個 ID，則加入
                                    const existingOption =
                                        userSearchOptions.value[key].find(
                                            (opt) => opt.value === ref
                                        );
                                    if (!existingOption) {
                                        userSearchOptions.value[key].push({
                                            label: name,
                                            value: ref
                                        });
                                    } else {
                                        // 更新現有選項的 label
                                        existingOption.label = name;
                                    }

                                    return ref;
                                });
                            } else {
                                // 對於其他類型，保持原始值
                                audienceRef = refArray;
                            }
                        }

                        return {
                            audience_type: rule.audience_type,
                            audience_ref: audienceRef
                        };
                    }
                );
            } else {
                formData.visibility_rules = [];
            }

            // 處理 executable_rules
            if (data.executable_rules && Array.isArray(data.executable_rules)) {
                formData.executable_rules = data.executable_rules.map(
                    (rule, ruleIndex) => {
                        let actorRef = [];
                        if (rule.actor_ref) {
                            const refArray = Array.isArray(rule.actor_ref)
                                ? rule.actor_ref
                                : rule.actor_ref.split(',');

                            // 處理名稱字串（可能包含多個名稱，用逗號分隔）
                            const names = rule.actor_name
                                ? rule.actor_name
                                      .split(',')
                                      .map((n) => n.trim())
                                : [];

                            // 根據 actor_type 找到對應的選項，確保值類型匹配
                            const typeConfig =
                                props.missionOptions.executable_actor_types?.find(
                                    (type) => type.value === rule.actor_type
                                );
                            const options = typeConfig?.options || [];

                            if (options.length > 0) {
                                // 根據選項的 value 類型來轉換，確保能正確匹配
                                actorRef = refArray.map((ref) => {
                                    // 嘗試在選項中找到匹配的項目
                                    const matchedOption = options.find(
                                        (opt) => {
                                            const optValue =
                                                opt.id ||
                                                opt.code ||
                                                opt.value ||
                                                opt.name;
                                            return (
                                                String(optValue) === String(ref)
                                            );
                                        }
                                    );

                                    if (matchedOption) {
                                        // 返回選項的實際 value（用於綁定）
                                        return (
                                            matchedOption.id ||
                                            matchedOption.code ||
                                            matchedOption.value ||
                                            matchedOption.name
                                        );
                                    }

                                    // 如果找不到匹配，保持原始值
                                    return ref;
                                });
                            } else if (rule.actor_type === 'user') {
                                // 對於 user 類型，需要將名稱加入到搜尋選項中
                                const key = `executable_${ruleIndex}`;
                                actorRef = refArray.map((ref, refIndex) => {
                                    const name = names[refIndex] || ref;

                                    // 初始化搜尋選項
                                    if (!userSearchOptions.value[key]) {
                                        userSearchOptions.value[key] = [];
                                    }

                                    // 如果選項中還沒有這個 ID，則加入
                                    const existingOption =
                                        userSearchOptions.value[key].find(
                                            (opt) => opt.value === ref
                                        );
                                    if (!existingOption) {
                                        userSearchOptions.value[key].push({
                                            label: name,
                                            value: ref
                                        });
                                    } else {
                                        // 更新現有選項的 label
                                        existingOption.label = name;
                                    }

                                    return ref;
                                });
                            } else {
                                // 如果沒有選項，保持原始值
                                actorRef = refArray;
                            }
                        }

                        return {
                            actor_type: rule.actor_type,
                            actor_ref: actorRef
                        };
                    }
                );
            } else {
                formData.executable_rules = [];
            }

            // 如果有資料，則預設展開該區塊
            if (formData.visibility_rules.length > 0) {
                if (!sectionsActiveKeys.value.includes('visibility')) {
                    sectionsActiveKeys.value.push('visibility');
                }
            }
            if (formData.executable_rules.length > 0) {
                if (!sectionsActiveKeys.value.includes('executable')) {
                    sectionsActiveKeys.value.push('executable');
                }
            }
            if (formData.rewards.length > 0) {
                if (!sectionsActiveKeys.value.includes('rewards')) {
                    sectionsActiveKeys.value.push('rewards');
                }
            }
        }
    } catch (error) {
        console.error('載入主線資料失敗:', error);
        handleHttpError(error, '載入主線資料');
        showErrorMessage('載入主線資料失敗');
    }
};

// 監聽重複週期變化，觸發最大次數驗證
watch(
    () => formData.repeat_cycle,
    () => {
        if (formRef.value) {
            nextTick(() => {
                formRef.value.validateFields(['max_times_per_cycle']);
            });
        }
    }
);

// 監聽 editingId 變化（只在視窗關閉時重置表單）
watch(
    () => props.editingId,
    (newVal) => {
        if (!newVal && !modalVisible.value) {
            resetForm();
        }
    }
);

// 監聽 modalVisible 變化（只在這裡載入資料，避免重複呼叫）
watch(modalVisible, (newVal) => {
    if (newVal) {
        if (props.editingId) {
            loadEditData();
        } else {
            resetForm();
        }
    } else {
        resetForm();
        emit('update:editingId', null);
    }
});

// 提交表單
const handleSubmit = async () => {
    try {
        if (formRef.value) {
            await formRef.value.validate();
        }

        // 統一處理提交資料格式
        const submitData = processSubmitData(formData);

        if (props.editingId) {
            await updateMission(props.editingId, submitData);
            message.success('更新主線成功');
        } else {
            await createMission(submitData);
            message.success('新增主線成功');
        }

        emit('success');
        modalVisible.value = false;
        emit('update:editingId', null);
    } catch (error) {
        if (error?.errorFields) {
            // 表單驗證錯誤
            return;
        }
        handleHttpError(error, '儲存主線');
        showErrorMessage(props.editingId ? '更新主線失敗' : '新增主線失敗');
    }
};

// 取消
const handleCancel = () => {
    modalVisible.value = false;
    emit('update:editingId', null);
};

// 可見性規則管理
const addVisibilityRule = () => {
    if (!Array.isArray(formData.visibility_rules)) {
        formData.visibility_rules = [];
    }
    formData.visibility_rules.push({
        audience_type: undefined,
        audience_ref: []
    });
};

const removeVisibilityRule = (index) => {
    if (formData.visibility_rules && formData.visibility_rules.length > index) {
        formData.visibility_rules.splice(index, 1);
        // 清理對應的搜尋選項
        const key = `visibility_${index}`;
        if (userSearchOptions.value[key]) {
            delete userSearchOptions.value[key];
        }
    }
};

// 可執行規則管理
const addExecutableRule = () => {
    if (!Array.isArray(formData.executable_rules)) {
        formData.executable_rules = [];
    }
    formData.executable_rules.push({
        actor_type: undefined,
        actor_ref: []
    });
};

const removeExecutableRule = (index) => {
    if (formData.executable_rules && formData.executable_rules.length > index) {
        formData.executable_rules.splice(index, 1);
        // 清理對應的搜尋選項
        const key = `executable_${index}`;
        if (userSearchOptions.value[key]) {
            delete userSearchOptions.value[key];
        }
    }
};

// 獎勵管理
const addReward = () => {
    formData.rewards.push({
        reward_type: 'point',
        reference_id: undefined,
        value: undefined
    });
};

const removeReward = (index) => {
    formData.rewards.splice(index, 1);
};

// 處理獎勵類型變更
const handleRewardTypeChange = (index, value) => {
    const reward = formData.rewards[index];
    if (value === 'exp') {
        reward.reward_type = 'exp';
        reward.reference_id = undefined;
    } else {
        reward.reward_type = 'point';
        reward.reference_id = value;
    }
};

// 獲取可見性類型的選項
const getVisibilityTypeOptions = (audienceType) => {
    if (!audienceType) return [];
    const typeConfig = props.missionOptions.visibility_audience_types?.find(
        (t) => t.value === audienceType
    );
    return typeConfig?.options || [];
};

// 獲取可執行類型的選項
const getExecutableTypeOptions = (actorType) => {
    if (!actorType) return [];
    const typeConfig = props.missionOptions.executable_actor_types?.find(
        (t) => t.value === actorType
    );
    return typeConfig?.options || [];
};

// 處理規則類型變更
const handleRuleTypeChange = (ruleType, index) => {
    if (ruleType === 'visibility') {
        const rule = formData.visibility_rules[index];
        const key = `visibility_${index}`;
        if (userSearchOptions.value[key]) {
            delete userSearchOptions.value[key];
        }
        rule.audience_ref = [];
    } else if (ruleType === 'executable') {
        const rule = formData.executable_rules[index];
        const key = `executable_${index}`;
        if (userSearchOptions.value[key]) {
            delete userSearchOptions.value[key];
        }
        rule.actor_ref = [];
    }
};

// 獲取可見性規則的 placeholder
const getVisibilityPlaceholder = (audienceType) => {
    if (!audienceType) return '請先選擇類型';
    const typeConfig = props.missionOptions.visibility_audience_types?.find(
        (t) => t.value === audienceType
    );
    if (!typeConfig) return '選擇值';
    return `選擇${typeConfig.label}`;
};

// 獲取可見性規則的輸入 placeholder
const getVisibilityInputPlaceholder = (audienceType) => {
    if (!audienceType) return '請先選擇類型';
    const typeConfig = props.missionOptions.visibility_audience_types?.find(
        (t) => t.value === audienceType
    );
    if (!typeConfig) return '輸入值';
    return `輸入${typeConfig.label}名稱`;
};

// 獲取可執行規則的 placeholder
const getExecutablePlaceholder = (actorType) => {
    if (!actorType) return '請先選擇類型';
    const typeConfig = props.missionOptions.executable_actor_types?.find(
        (t) => t.value === actorType
    );
    if (!typeConfig) return '選擇值';
    return `選擇${typeConfig.label}`;
};

// 獲取可執行規則的輸入 placeholder
const getExecutableInputPlaceholder = (actorType) => {
    if (!actorType) return '請先選擇類型';
    const typeConfig = props.missionOptions.executable_actor_types?.find(
        (t) => t.value === actorType
    );
    if (!typeConfig) return '輸入值';
    return `輸入${typeConfig.label}名稱`;
};

// 獲取會員搜尋選項
const getUserSearchOptions = (ruleType, index) => {
    const key = `${ruleType}_${index}`;
    return userSearchOptions.value[key] || [];
};

// 獲取會員搜尋載入狀態
const getUserSearchLoading = (ruleType, index) => {
    const key = `${ruleType}_${index}`;
    return userSearchLoading.value[key] || false;
};

// 處理會員搜尋
const handleUserSearch = (ruleType, index, keyword) => {
    const key = `${ruleType}_${index}`;

    // 清除之前的計時器
    if (userSearchTimers.value[key]) {
        clearTimeout(userSearchTimers.value[key]);
    }

    // 防抖處理
    userSearchTimers.value[key] = setTimeout(async () => {
        const kw = keyword && keyword.trim();
        if (!kw || kw.length < 2) {
            userSearchOptions.value[key] = [];
            return;
        }

        try {
            userSearchLoading.value[key] = true;
            const res = await searchUsers({ name: kw, limit: 20 });
            if (res?.result) {
                const arr = Array.isArray(res.data)
                    ? res.data
                    : res.data?.data || [];
                userSearchOptions.value[key] = arr.map((u) => ({
                    label: u.name || `#${u.id}`,
                    value: u.id
                }));
            }
        } catch (e) {
            console.error('載入會員選項失敗:', e);
            userSearchOptions.value[key] = [];
        } finally {
            userSearchLoading.value[key] = false;
        }
    }, USER_SEARCH_DEBOUNCE_MS);
};

// 暴露方法給父元件
defineExpose({
    resetForm,
    loadEditData
});
</script>

<style scoped>
/* 表單區塊摺疊面板樣式 */
.form-sections-collapse {
    background: transparent !important;
    border: none !important;
}

.form-sections-collapse :deep(.ant-collapse-item) {
    background: transparent !important;
    border: none !important;
    margin-bottom: 8px !important;
}

.form-sections-collapse :deep(.ant-collapse-header) {
    background: rgba(255, 255, 255, 0.95) !important;
    border: 1px solid rgba(42, 74, 122, 0.2) !important;
    border-radius: 12px !important;
    padding: 12px 16px !important;
    transition: all 0.3s ease !important;
}

.form-sections-collapse :deep(.ant-collapse-header:hover) {
    background: rgba(255, 255, 255, 1) !important;
    border-color: rgba(42, 74, 122, 0.4) !important;
    box-shadow: 0 2px 8px rgba(42, 74, 122, 0.2) !important;
}

.form-sections-collapse :deep(.ant-collapse-header:focus) {
    outline: none !important;
}

.form-sections-collapse :deep(.ant-collapse-content) {
    background: transparent !important;
    border: none !important;
    border-radius: 0 0 12px 12px !important;
    padding: 0 !important;
}

.form-sections-collapse :deep(.ant-collapse-content-box) {
    padding: 0 !important;
}

.form-sections-collapse :deep(.ant-collapse-expand-icon) {
    color: #2a4a7a !important;
    font-size: 14px !important;
}

.form-sections-collapse :deep(.ant-collapse-expand-icon:hover) {
    color: #3b6ea5 !important;
}

.section-header {
    color: #2a2a3a !important;
    font-family: 'Courier New', monospace !important;
    font-weight: 600 !important;
    font-size: 15px !important;
}

.section-note {
    font-weight: 400;
    font-size: 12px;
    color: #8a8a9a;
    margin-left: 4px;
}

.form-section-panel {
    border: none !important;
}

.form-section-card-inner {
    background: rgba(255, 255, 255, 0.95) !important;
    border: 1px solid rgba(42, 74, 122, 0.2) !important;
    border-radius: 8px !important;
    box-shadow: 0 2px 8px rgba(42, 74, 122, 0.1) !important;
    margin-top: 4px !important;
}

.form-section-card-inner :deep(.ant-card-body) {
    padding: 12px !important;
}

.form-section-card-inner :deep(.ant-form-item) {
    margin-bottom: 8px !important;
}

.form-section-card-inner :deep(.ant-form-item:last-child) {
    margin-bottom: 0 !important;
}

/* 空狀態時減少 padding */
.form-section-card-inner:has(.no-rules) :deep(.ant-card-body),
.form-section-card-inner:has(.no-rewards) :deep(.ant-card-body) {
    padding: 4px 12px !important;
}

/* 規則和獎勵區塊樣式 */
.rules-section,
.rewards-section {
    width: 100%;
}

.rules-header,
.rewards-header {
    margin-bottom: 12px;
}

.rules-list,
.rewards-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.rule-item,
.reward-item {
    padding: 12px;
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid rgba(42, 74, 122, 0.15);
    border-radius: 6px;
    transition: all 0.2s ease;
}

.rule-item:hover,
.reward-item:hover {
    border-color: rgba(42, 74, 122, 0.3);
    background: rgba(255, 255, 255, 0.7);
}

.no-rules,
.no-rewards {
    padding: 12px;
    text-align: center;
}

/* 隱藏空狀態的 image */
.no-rules :deep(.ant-empty-image),
.no-rewards :deep(.ant-empty-image) {
    display: none;
}

.delete-rule-btn {
    color: #ff4d4f !important;
}

.delete-rule-btn:hover {
    color: #ff7875 !important;
    background: rgba(255, 77, 79, 0.1) !important;
}
</style>
